/** @format */

/**
 * User account lifecycle status configuration.
 * Used across admin UI for badges, filters, and status controls.
 */

export const STATUS_CONFIG = {
	active: {
		label: 'Active',
		className: 'bg-green-100 text-green-800 border-green-200',
	},
	inactive: {
		label: 'Inactive',
		className: 'bg-gray-100 text-gray-600 border-gray-200',
	},
	archived: {
		label: 'Archived',
		className: 'bg-blue-100 text-blue-600 border-blue-200',
	},
	deleted: {
		label: 'Deleted',
		className: 'bg-red-100 text-red-600 border-red-200',
	},
};

/** Filter options for admin client list dropdown. Excludes 'deleted'. */
export const STATUS_FILTER_OPTIONS = [
	{ value: 'active', label: 'Active' },
	{ value: 'inactive', label: 'Inactive' },
	{ value: 'archived', label: 'Archived' },
	{ value: 'all', label: 'All Clients' },
];

/** All status options for admin detail page dropdown. */
export const STATUS_CHANGE_OPTIONS = [
	{ value: 'active', label: 'Active' },
	{ value: 'inactive', label: 'Inactive' },
	{ value: 'archived', label: 'Archived' },
	{ value: 'deleted', label: 'Deleted' },
];
